import React from 'react';
import Edit from 'containers/rest/Edit';
import Form from '../components/Form';

const ConfigGeneralsEdit = props => (
  <Edit {...props} resource="configGenerals">
    <Form />
  </Edit>
);

ConfigGeneralsEdit.propTypes = {};

export default ConfigGeneralsEdit;
